module.exports = __webpack_public_path__ + "static/media/Chuvoso-Cinza.0b58a2a2.svg";